<div class="container" *ngIf="!loading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Kunden</h4>
        </div>
    </div>
    <div class="row marginBottom2Rem" [formGroup]="filterForm">
        <div class="col-sm-3">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suche</mat-label>
                <input type="text" matInput formControlName="searchTerm" placeholder="suchen.."
                    (keydown)="onKeydown($event)">
            </mat-form-field>
        </div>
        <div class="col-sm-3">
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Status</mat-label>
                <mat-select formControlName="filterByState" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByState.value != null ">
                            {{this.filterForm.controls.filterByState.value | translateFilterCustomer :
                            'filterByState'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByState.value?.length > 1">
                            (+{{this.filterForm.controls.filterByState.value.length - 1 }}
                            {{this.filterForm.controls.filterByState.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of states"
                        [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
                    <!-- <button mat-button mat-raised-button color="accent" class="full-width" (click)="filterCustomers()">
                            Anwenden
                        </button> -->
                </mat-select>

            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Rolle </mat-label>
                <mat-select formControlName="filterByRoles" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByRoles.value != null ">
                            {{this.filterForm.controls.filterByRoles.value | translateFilterServiceRole }}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByRoles.value?.length > 1">
                            (+{{this.filterForm.controls.filterByRoles.value.length - 1 }}
                            {{this.filterForm.controls.filterByRoles.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of roles"
                        [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>

        </div>

        <div class="col-sm-12">
            <button mat-button mat-raised-button color="accent" (click)="filterCustomers()">
                Anwenden
            </button>

            <button mat-button mat-raised-button color="primary" (click)="resetFilter()" style="margin-left: 15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column w5">
                            {{i+1}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="user" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Kunde
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{this.customerDisplayName(element)}} ({{element.username}})
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="address" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Anschrift
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span>
                                {{element.address?.street }} <br>
                                {{element.address?.postcode }} {{element.address?.city }}
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="contact" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Kontakt
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span>
                                <a>{{element?.email}}</a>
                                <br>
                                <a>{{element?.phone}}</a>
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="type" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Rolle
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected>{{element.account.role.displayName }}</mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="state" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip color="primary" selected *ngIf="element.account.state == 'ACTIVE'">
                                    {{element.account.state | translateState }}</mat-chip>
                                <mat-chip color="warn" selected *ngIf="element.account.state == 'NEW'">
                                    {{element.account.state |
                                    translateState }}</mat-chip>
                                <mat-chip class="accentChip" selected
                                    *ngIf="element.account.state == 'DISABLE_REQUEST'">
                                    {{element.account.state | translateState }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'DELETED'">{{element.account.state |
                                    translateState }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'REJECTED'">{{element.account.state |
                                    translateState }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'DISABLED'">{{element.account.state |
                                    translateState }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'PENDING'">{{element.account.state |
                                    translateState }}</mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [matMenuTriggerFor]="edit">Bearbeiten</button>
                                <button mat-menu-item [matMenuTriggerFor]="state">Status</button>
                            </mat-menu>
                            <mat-menu #edit="matMenu">
                                <button mat-menu-item [routerLink]="['edit', element.publicId]">
                                    <span>Stammdaten</span>
                                </button>
                                <button mat-menu-item (click)="openResetPassword(element)">
                                    <span>Passwort zurücksetzen</span>
                                </button>
                            </mat-menu>

                            <mat-menu #state="matMenu">
                                <button mat-menu-item (click)="changeState(element, 'DISABLED')">Nutzer deaktivieren </button>
                                <button mat-menu-item (click)="changeState(element, 'DELETED')">Nutzer löschen </button>
                                <button mat-menu-item (click)="changeState(element, 'ACTIVE')">Nutzer aktivieren </button>
                            </mat-menu>
                 
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge
                    gefunden</span>
                <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size"
                    [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[12, 24, 36, 48]"
                    *ngIf="page">
                </mat-paginator>
            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['overviewCustomer']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>